import React from "react";
import { PopUpProps } from "./PopUp.types";
import { Overlay } from "../react-overlay/Overlay";
import { Message, OverlayWrapper, StatusContainer } from "./PopUp.styles";
import { Button } from "antd";
export const PopUp = ({
  isActive,
  isButtonDisabled,
  message,
  onOKClick,
}: PopUpProps) => {
  const [timer, setTimer] = React.useState(0);
  React.useEffect(() => {
    let interval: any;

    if (isButtonDisabled) {
      interval = setInterval(() => {
        setTimer((prevElapsedTime) => prevElapsedTime + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isButtonDisabled, timer]);
  return (
    <Overlay isVisible={isActive}>
      {isActive && (
        <>
          <OverlayWrapper>
            <StatusContainer>
              <Message>{message}</Message>
              <Message>Time elapsed: {timer} seconds</Message>
              <Button
                id = "ok-button"
                type="primary"
                onClick={onOKClick}
                loading={isButtonDisabled}
                disabled={isButtonDisabled}
              >
                Ok
              </Button>
            </StatusContainer>
          </OverlayWrapper>
        </>
      )}
    </Overlay>
  );
};
